<template>
    <div>
        <breadCrumb 
            :icon="'fa-clipboard-list-check'"
            :category="$t(`sideNav.navSalonReport`)"
            :subCategory="$t(`subMenu.salon_report_order`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="row mt-3" v-if="!filterObj.voided">
            <div class="col-sm-6 col-xl-3" v-for="box in salesReportSummaryBox" :key="box.id">
                <div class="p-3 rounded overflow-hidden position-relative text-white mb-g" :class="box.background">
                    <div class="">
                        <h3 class="fs-xxl d-block l-h-n m-0 fw-500">
                            {{box.value}}
                            <small class="m-0 l-h-n fw-400 text-capitalize">{{box.text}}</small>
                        </h3>
                    </div>
                    <i class="fal position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1" :class="box.icon" style="font-size:5rem"></i>
                </div>
            </div>
        </div>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4">
                    <orderFilter ref="orderFilter" @filterOrder="filterOrder"></orderFilter>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <div class="tab-content">
                            <orderList ref="orderList" @setExportData="setExportData" @onModalClose="onModalClose"></orderList>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    </div>
</template>
<script>
import OrderFilter from './Order_Filter'
import OrderList from './Order_List'
import _ from 'lodash';
import moment from 'moment'
import BreadCrumb from './../../Bread_Crumb'
import {handleSessionExpired, setSummaryBoxLabel} from './../../../../assets/js/dashboard/dashboard'
import box, {getPaymentTypeTitle, calculateSalesReportTotal} from './../../../../assets/js/dashboard/salonReport/salonReport'
export default {
    name: 'reportOrder',
    components:{
        OrderFilter, OrderList, BreadCrumb
    },
    data(){
        return{
            salesReportSummaryBox: [],
            outlet: [],
            paymentType: [], filterObj: {}, 
            
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.setSummaryBoxLabel()
        }
    },
    methods:{
        setExportData(item){
            this.exportObj = item
            this.$refs.orderFilter.setExportData(item)
        },
        async filterOrder(filterObj){
            this.filterObj = filterObj
            this.$refs.orderList.isSpinnerShow = true
            var completed = await this.getCompletedItems(filterObj)
            var sales = await this.getSalesItems(filterObj)
            var payment = await this.getPaymentItems(filterObj)

            for(var c=0; c<completed.length; c++){
                for(var s=0; s<sales.length; s++){
                    if(completed[c].salesID == sales[s].salesID){
                        completed[c].rounding = sales[s].otherAmount.rounding
                    }
                }
            }

            for(var i=0; i<completed.length; i++){
                var arrPayment = []
                for(var p=0; p<payment.length; p++){
                    if(completed[i].salesID == payment[p].salesID){
                        arrPayment.push({
                            paymentTypeID: payment[p].paymentTypeID,
                            paymentMethod: payment[p].paymentMethod,
                            paymentAmount: payment[p].amount,
                        })
                    }
                }
                completed[i].payment = arrPayment
            }

            for(var k=0; k<completed.length; k++){
                if(completed[k].payment.length == 0){
                    completed[k].payment.push({
                        paymentTypeID: "-",
                        paymentMethod: "-",
                        paymentAmount: "-",
                    })
                }
            }

            // var orderItems = []
            // if(filterObj.voided){
            //     for(var j=0; j<completed.length; j++){
            //         if(completed[j].voidDate != 0){
            //             orderItems.push(completed[j])
            //         }
            //     }
            // }else{
            //     orderItems = completed
            // }
        
            this.$refs.orderList.setOrderItems(completed, filterObj)
            if(!filterObj.voided){
                this.setTotalData(completed)
            }
        },
        setTotalData(item){
            var data = calculateSalesReportTotal(item)   

            for(var i=0; i<this.salesReportSummaryBox.length; i++){
                switch(this.salesReportSummaryBox[i].id){
                    case"sales":
                        this.salesReportSummaryBox[i].value = parseFloat(data.totalSales).toFixed(2);
                        break
                    case"credit_redeem":
                        this.salesReportSummaryBox[i].value = parseFloat(data.totalCredits).toFixed(2);
                        break
                    case"package_redeem":
                        this.salesReportSummaryBox[i].value = parseFloat(data.totalPackage).toFixed(2);
                        break
                    case"total":
                        this.salesReportSummaryBox[i].value = parseFloat(data.subTotal).toFixed(2);
                        break
                }
            }
        },
        async getCompletedItems(filterObj){
            var dateFilter = "?startDate=" + moment(filterObj.date.startDate).format('DD/MM/YYYY') + "&endDate=" + moment(filterObj.date.endDate).format('DD/MM/YYYY')
            var outletFilter = filterObj.outlet.id == "all" ? "" : "&outletID=" + filterObj.outlet.id
            var voidFilter = "&active=" + (filterObj.voided ? "0" : "1")
            var searchFilter = filterObj.search == "" ? "" : "&search=" + filterObj.search

            let QUERY_STRING = dateFilter + outletFilter + searchFilter + voidFilter

            const url =  this.$api.REPORT_COMPLETED + QUERY_STRING;
            var result = [];
            await this.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()}
            })
            .then(function(response) {
                result = response.data.result;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == "Invalid Token"){
                    handleSessionExpired();   
                }
            })
            return result;
        },
        async getSalesItems(filterObj){
            var dateFilter = "?startDate=" + moment(filterObj.date.startDate).unix() + "&endDate=" + moment(filterObj.date.endDate).unix()
            var outletFilter = filterObj.outlet.id == "all" ? "" : "&outletID=" + filterObj.outlet.id
            var searchFilter = filterObj.search == "" ? "" : "&search=" + filterObj.search
            var voidFilter = "&active=" + (filterObj.voided ? "0" : "1")

            let QUERY_STRING = dateFilter + outletFilter + searchFilter + voidFilter

            const url =  this.$api.REPORT_SALES + QUERY_STRING;
            var result = [];
            await this.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()}
            })
            .then(function(response) {
                result = response.data.result;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == "Invalid Token"){
                    handleSessionExpired();   
                }
            })
            return result
        },
        async getPaymentItems(filterObj){
            let DATE_QUERY_STRING = "?startCreateDate=" + moment(filterObj.date.startDate).unix() +  "&endCreateDate=" + moment(filterObj.date.endDate).unix()
            let OUTLET_QUERY_STRING = filterObj.outlet.id == "all" ? "" : "&outletID=" + filterObj.outlet.id
            const url = this.$api.REPORT_PAYMENT + DATE_QUERY_STRING + OUTLET_QUERY_STRING

            let $vm = this;
            var results = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                results = response.data.result;
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == "Invalid Token"){
                    handleSessionExpired();   
                }
            })
            for(var i=0; i<results.length; i++){
                results[i]['paymentMethod'] = getPaymentTypeTitle(results[i].paymentTypeID, this.paymentType)
            }
            return results
        },
        async getPaymentConfiguration(){
            let $vm = this;
            var results = []

            await $vm.$axios({
                method: 'get', 
                url: $vm.$api.BRAND_PAYMENT,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                results = response.data.payments;
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == "Invalid Token"){
                    handleSessionExpired();   
                }
            })
            return results
        },
        async getPaymentType(){
            var paymentType = [
                 {
                    "paymentTypeID": 1,
                    "title": "cash"
                },
                {
                    "paymentTypeID": 2,
                    "title": "credit card"
                },
                {
                    "paymentTypeID": 3,
                    "title": "debit card"
                },
                {
                    "paymentTypeID": 4,
                    "title": "online"
                },
                {
                    "paymentTypeID": 5,
                    "title": "e-wallet 1"
                },
                {
                    "paymentTypeID": 6,
                    "title": "e-wallet 2"
                },
                {
                    "paymentTypeID": 7,
                    "title": "store credits"
                },
                {
                    "paymentTypeID": 8,
                    "title": "store points"
                },
                {
                    "paymentTypeID": 9,
                    "title": "outstandings"
                },
                {
                    "paymentTypeID": 10,
                    "title": "credits redeem"
                },
                {
                    "paymentTypeID": 11,
                    "title": "package redeem"
                },
                {
                    "paymentTypeID": 12,
                    "title": "e-wallet 3"
                },
                {
                    "paymentTypeID": 13,
                    "title": "Option 4"
                },
                {
                    "paymentTypeID": 14,
                    "title": "Option 5"
                },
                {
                    "paymentTypeID": 15,
                    "title": "Option 6"
                },
                {
                    "paymentTypeID": 16,
                    "title": "Option 7"
                },
                {
                    "paymentTypeID": 17,
                    "title": "Option 8"
                },
                {
                    "paymentTypeID": 18,
                    "title": "Option 9"
                },
                {
                    "paymentTypeID": 19,
                    "title": "Option 10"
                }
            ]

            var paymentConfig = await this.getPaymentConfiguration()

            paymentType = paymentType.map(function(p){
                if(p.paymentTypeID == 5){
                    return { ...p, title: paymentConfig[0] }
                }else if(p.paymentTypeID == 6){
                    return { ...p, title: paymentConfig[1] }
                }else if(p.paymentTypeID == 12){
                    return { ...p, title: paymentConfig[2] }
                }else if(p.paymentTypeID > 12){
                    return { ...p, title: paymentConfig[p.paymentTypeID-10] }
                }else{
                    return p
                }
            });
            this.paymentType = paymentType
        },
        setSummaryBoxLabel(){
            var _box = box.salesReportSummaryBox
            this.salesReportSummaryBox = setSummaryBoxLabel(this, 'sales', _box.slice())
        },

        onModalClose() {
            this.filterOrder(this.filterObj)
        },
    },
    async mounted(){
        let $vm = this
        $vm.setSummaryBoxLabel()
        $vm.getPaymentType()
    },
}
</script>